<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rZeCxB/cover.jpeg?1742348670786" alt="This image is the cover for the book Evening Light Over Kouraki"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evening Light Over Kouraki
      </h1>
      <p class="bookDescription body article font2">
        <p><em>This is a story about the search for identity.</em></p><p>Michael Dowd, an out-of-work theater misfit, feels like a failure, and he traces this feeling back to being adopted. Driven to uncover his roots, Michael approaches the adoption agency, only to be denied the answers he seeks. Yet one clue surfaces: his birth name, Kokolakis, hints at Greek origins. With that small lead, he travels to Greece in search of his family.</p><p>In the secluded village of Kouraki, he encounters a colorful cast of characters: Elias, the local fool who becomes his unlikely companion; Wolff, a German expat and eccentric inventor; Sotiri, a warm-hearted olive-picker; Penelope, a sharp-minded intellectual from Athens; and Mihaeli, the village mayor, who warns him of the dangers his search could awaken. Each encounter draws Michael deeper into a mystery that tests his resolve and uncovers long-buried secrets.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Moore
      </h2>
      
      <p class="authorDescription body article"><p style="margin: 0mm; font-size: 16px; font-family: Calibri, sans-serif; text-align: justify;"><span style='font-size:15px;font-family:"Times New Roman",serif;'>David Moore was born in Ireland and later emigrated to Montreal. Moore published his first collection of poetry, <em>Silence</em>, in 2016. Other books followed: <em>Poems 2020, The March of the Copylong Shadows, 2020, Fame and Fortune, The Copyright Curse of Cassandra, 2021, The Life of a Slave, 2022,</em> and <em>The Timeless Love of Billy B for Scheherazade, 2022</em>. <em>Evening Light over Kouraki</em> is his first novel. He is presently working on another full-length novel, <em>Things Not Said</em>. Moore has already made his mark as a visual artist in Canada, the USA, and Europe. </span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fde8c5d